import {
    Component,
    ViewChild,
    AfterViewInit,
    OnDestroy,
    ViewContainerRef,
    ComponentRef,
    ChangeDetectorRef
} from "@angular/core";
import { EdpToastItemComponent } from "../edp-toast-item/edp-toast-item.component";

@Component({
    selector: "edp-toast-container",
    templateUrl: "./edp-toast-container.component.html",
    styleUrls: ["./edp-toast-container.component.scss"]
})
export class EdpToastContainerComponent implements AfterViewInit, OnDestroy {
    public componentRefList: Map<string, ComponentRef<EdpToastItemComponent>>;
    @ViewChild("container", { static: true, read: ViewContainerRef })
    public container: ViewContainerRef;
    public isOpened = false;
    protected onlyRunAfterInit: Promise<any>;
    protected resolver: (value?: unknown) => void;

    public constructor(
        private cd: ChangeDetectorRef
    ) {
        this.componentRefList = new Map();
        // we need this promise in order to prevent an endless loop in the
        // ngAfterViewInit function calling this.loadPreloadedComponents method
        // this bug can be seen in the previous version / commit
        this.onlyRunAfterInit = new Promise(resolver => {
            this.resolver = resolver;
        }).then(this.loadPreloadedComponents.bind(this));
    }

    public ngAfterViewInit() {
        this.resolver();
    }

    public ngOnDestroy() {
        this.onlyRunAfterInit.then(() => {
            this.componentRefList.forEach((component, key) => {
                if (component && component.destroy) {
                    component.destroy();
                }

                this.componentRefList.delete(key);
            });
        });
    }

    public isOpen(): boolean {
        return this.isOpened;
    }

    public expand(evt?: Event): void {
        if (!this.isOpen()) {
            this.isOpened = true;
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
            }
        }
    }

    public collapse(evt?: Event): void {
        if (this.isOpen()) {
            this.isOpened = false;
            if (evt && evt.stopPropagation) {
                evt.stopPropagation();
            }
        }
    }

    public onTouchEnd(evt: Event): void {
        if (this.isOpened) {
            this.collapse(evt);
        } else {
            this.expand(evt);
        }
    }

    public removeChildComponent(key: string, alsoDestroy = false): void {
        this.onlyRunAfterInit.then(() => {
            const component = this.componentRefList.get(key);

            if (component) {
                if (component.instance) {
                    component.instance.setParentComponent(null);
                }

                if (alsoDestroy && component.destroy) {
                    if (alsoDestroy) {
                        component.destroy();
                    }
                }
            }

            this.componentRefList.delete(key);
            if (this.componentRefList.size <= 0) {
                this.collapse();
            }
        });
    }

    public async loadChildComponent(
        component: ComponentRef<EdpToastItemComponent>,
        index: number = -1,
        reloadView = false
    ): Promise<string> {
        return this.onlyRunAfterInit.then(() => {
            const id = new Date().getTime().toString();
            this.container.insert(
                component.hostView,
                index < 0 ? this.container.length : index
            );
            component.instance.setParentComponent(this);
            this.componentRefList.set(id, component);
            if (reloadView) {
                // it should reload automaticly, but in case
                // you need to force it, it's here
                this.cd.detectChanges();
            }

            return id;
        });
    }

    private loadPreloadedComponents(): void {
        this.componentRefList.forEach((component, key) => {
            if (component && component.hostView) {
                this.loadChildComponent(component, -1, false);
            } else {
                this.componentRefList.delete(key);
            }
        });

        this.cd.detectChanges();
    }
}
